import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { business } from "@/data/business";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#14324A] text-white mt-24" data-testid="site-footer">
      <div className="container-page py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="bg-white rounded-2xl p-4 inline-block">
            <Logo variant="footer" />
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed">
            {business.shortDescription}
          </p>
          <div className="flex items-center gap-3 mt-6" aria-label="Social media">
            <a href={business.socials.facebook} className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#1677C8] transition-colors inline-flex items-center justify-center" aria-label="Facebook" data-testid="social-facebook">
              <Facebook size={18} />
            </a>
            <a href={business.socials.instagram} className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#1677C8] transition-colors inline-flex items-center justify-center" aria-label="Instagram" data-testid="social-instagram">
              <Instagram size={18} />
            </a>
            <a href={business.socials.linkedin} className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#1677C8] transition-colors inline-flex items-center justify-center" aria-label="LinkedIn" data-testid="social-linkedin">
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-lg mb-4">Quick links</h4>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/about" className="hover:text-[#FFD45C]" data-testid="footer-link-about">About Us</Link></li>
            <li><Link to="/for-schools" className="hover:text-[#FFD45C]" data-testid="footer-link-schools">For Schools</Link></li>
            <li><Link to="/for-parents" className="hover:text-[#FFD45C]" data-testid="footer-link-parents">For Parents</Link></li>
            <li><Link to="/dental-van" className="hover:text-[#FFD45C]" data-testid="footer-link-van">Our Dental Van</Link></li>
            <li><Link to="/faqs" className="hover:text-[#FFD45C]" data-testid="footer-link-faqs">FAQs</Link></li>
            <li><Link to="/contact" className="hover:text-[#FFD45C]" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-white/75">
            <li><Link to="/services" className="hover:text-[#FFD45C]">Dental check-ups</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Professional cleans</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Fluoride treatments</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Fissure sealants</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Dental fillings</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Gum disease treatment</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Oral health education</Link></li>
            <li><Link to="/services" className="hover:text-[#FFD45C]">Treatment planning</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-[#FFD45C]" /><a href={`tel:${business.phone.replace(/\s+/g, "")}`} className="hover:text-[#FFD45C] transition-colors" data-testid="footer-phone">{business.phone}</a></li>
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-[#FFD45C]" /><a href={`mailto:${business.email}`} className="hover:text-[#FFD45C] transition-colors break-all" data-testid="footer-email">{business.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#FFD45C]" /><span>{business.address}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/60">© {year} {business.name}. All rights reserved.</p>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-white/75">
            <li><Link to="/privacy-policy" className="hover:text-[#FFD45C]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#FFD45C]" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/cookies-policy" className="hover:text-[#FFD45C]" data-testid="footer-cookies">Cookies Policy</Link></li>
            <li><Link to="/accessibility" className="hover:text-[#FFD45C]" data-testid="footer-accessibility">Accessibility</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#FFD45C]" data-testid="footer-disclaimer">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
